import { ref } from 'vue';
import {
  countryCodeIsIndia,
  peekCachedCurrentIpCountryCode,
  resolveCountryCodeFromCurrentIp,
} from '@/utils/ip-country-lookup';

/**
 * 落地印度 UPI/原生支付仅当前出口 IP 为 IN 时展示。
 * 资料国家码不参与；探测失败 fail-closed（不展示）。
 */
export const INDIA_PAY_IP_GUARD_ENABLED = true;

export const indiaPayIpAllowed = ref(
  !INDIA_PAY_IP_GUARD_ENABLED || countryCodeIsIndia(peekCachedCurrentIpCountryCode())
);

export function resetIndiaPayIpAllowed() {
  indiaPayIpAllowed.value = !INDIA_PAY_IP_GUARD_ENABLED;
}

/**
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
export async function resolveIsIndiaPayIpAllowed({ forceRefresh = false } = {}) {
  if (!INDIA_PAY_IP_GUARD_ENABLED) {
    indiaPayIpAllowed.value = true;
    return true;
  }
  const countryCode = await resolveCountryCodeFromCurrentIp({ forceRefresh }).catch(() => null);
  const allowed = countryCodeIsIndia(countryCode);
  indiaPayIpAllowed.value = allowed;
  return allowed;
}
